export default __webpack_public_path__ + "static/media/Yaysapplight-05.03bbc9b8.png";